type NodeRequire = (id: string) => unknown;

const nodeCrypto = (() => {
  try {
    if (typeof process !== 'undefined' && process.versions?.node) {
      // eslint-disable-next-line @typescript-eslint/no-implied-eval, no-eval
      const nodeRequire = (0, eval)('require') as NodeRequire;
      return nodeRequire('crypto') as typeof import('crypto');
    }
  } catch {
    /* noop */
  }
  return undefined;
})();

/**
 * Generates a deterministic hash for the given input string.
 * In Node.js environments, it uses the built-in crypto module.
 * In browsers, it falls back to a simple non-cryptographic hash.
 */
export const generateHash = (input: string): string => {
  if (input.length === 0) {
    throw new Error('Value needs to be at least 1 character long.');
  }

  if (nodeCrypto) {
    return nodeCrypto.createHash('sha256').update(input).digest('hex');
  }

  let hash = 0;
  for (let index = 0; index < input.length; index++) {
    const char = input.charCodeAt(index);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  return Math.abs(hash).toString(16).padStart(8, '0');
};
